import script from "./SheetMusicSing.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetMusicSing.vue?vue&type=script&setup=true&lang=ts"

import "./SheetMusicSing.vue?vue&type=style&index=0&id=0886b176&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0886b176"]])

export default __exports__